import { addYears } from 'date-fns';

export enum TimeFilterPresets {
  CURRENT_DAY = 'CURRENT_DAY',
  CURRENT_WEEK = 'CURRENT_WEEK',
  CURRENT_MONTH = 'CURRENT_MONTH',
  CURRENT_QUARTER = 'CURRENT_QUARTER',
  CURRENT_YEAR = 'CURRENT_YEAR',
  FUTURE = 'FUTURE',
  CUSTOM_RANGE = 'CUSTOM_RANGE',
}

export const MAX_SAFE_DATE = addYears(new Date(), 999);

export const TIME_CONTROL_BUTTON_SELECTOR = 'time-control-button';
